import { fetchApi } from '../baseApi';

export function getAllPrimarySpecialties() {
    return new Promise((resolve, reject) => {
        fetchApi(`api/primary_specialties`, 'GET', undefined).then((result) => {
            resolve(result);
        }).catch(() => {
            reject(new Error('Can not get all primary specialties!'));
        });
    });
}


// WEBPACK FOOTER //
// ./src/api/masterdata/index.ts